module.exports = __webpack_public_path__ + "assets/bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 1658
// module chunks = 7